import { IconTab } from "@/src/components/iconTab";
import { Shift, Hospitalisation, Patient } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getUserId } from "@/src/utils/utils";
import { FaRegMoon, FaStethoscope } from "react-icons/fa";
import { getStandardConfidentiality } from "../../patients/confidentialitiesHook";
import openEvolutionItemStandardForm from "../openEvolutionItemStandardForm";

function ShiftButton({
  patient,
  parent,
  onSave,
}: {
  patient: Patient;
  parent: Hospitalisation;
  onSave: (item: Shift) => void;
}) {
  return (
    <IconTab
      id={"shift"}
      activeTabId={null}
      isHorizontal={true}
      name={"Mot de la garde"}
      icon={<FaRegMoon size={20} />}
      onChange={async () => {
        let item: Shift = {
          type: "shift",
          patient,
          creator: getUserId(),
          parent,
          functionalSigns: [],
          physicalSigns: [],
          readBy: [getUserId()],
          confidentiality: getStandardConfidentiality(patient),
        };

        await openEvolutionItemStandardForm({
          item,
          patient,
          onConfirm: async (newItem) => {
            newItem = await apiFetch("shifts", "addOne", {
              shift: newItem,
            });
            onSave(newItem);
          },
        });
      }}
    />
  );
}

export default ShiftButton;
